import { useState, useEffect, useMemo } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import ReporteCosecha from './ReporteCosecha';
import ReporteRegistroDiario from './ReporteRegistroDiario';
import { usePermisos } from '../context/PermisosContext';

export default function ReportesMetricas() {
  const { tienePermiso } = usePermisos();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const tabFromUrl = searchParams.get('tab');
  const esLegacyCrecimientos = tabFromUrl === 'crecimientos';

  // Solo dejamos la pestaña de Balanceado
  const pestanas = useMemo(() => {
    return [
      { id: 'registro-diario', label: 'Balanceado Consumido', icon: '📊', permiso: 'reportes.registro-diario' },
    ].filter((p) => tienePermiso(p.permiso));
  }, [tienePermiso]);

  const pestanaActiva = useMemo(() => {
    if (tabFromUrl && pestanas.some((p) => p.id === tabFromUrl)) {
      return tabFromUrl;
    }
    return pestanas[0]?.id || '';
  }, [tabFromUrl, pestanas]);

  useEffect(() => {
    if (esLegacyCrecimientos) {
      navigate('/muestreos?tab=crecimientos', { replace: true });
    }
  }, [esLegacyCrecimientos, navigate]);

  useEffect(() => {
    if (!pestanaActiva || esLegacyCrecimientos) return;
    if (tabFromUrl !== pestanaActiva) {
      const next = new URLSearchParams(searchParams);
      next.set('tab', pestanaActiva);
      setSearchParams(next, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pestanaActiva, esLegacyCrecimientos]);

  if (esLegacyCrecimientos) return null;

  if (pestanas.length === 0) {
    return (
      <div className="p-6 text-center text-gray-500">
        No tienes permiso para ver ninguna sección de reportes.
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full w-full bg-gray-100 overflow-y-auto">
      {pestanaActiva === 'registro-diario' && <ReporteRegistroDiario />}
    </div>
  );
}